
    import router from '@/router';
import { store } from '@/store';
import { computed, defineComponent } from 'vue'
    
    export default defineComponent({
        setup() {
            const websiteUrl = computed(() => {
                return process.env.VUE_APP_PAYMENT_GATEWAY_URL
            })
    
            const email = computed(() => {
                return process.env.VUE_APP_MAIL
            })
    
            const language = computed(() => {
                return window.localStorage.getItem('language');
            })
    
            const linkedin = computed(() => {
                return process.env.VUE_APP_LINKEDIN
            })
    
            const facebook = computed(() => {
                return process.env.VUE_APP_FACEBOOOK
            })
    
            const instagram = computed(() => {
                return process.env.VUE_APP_INSTAGRAM
            })
    
            const tiktok = computed(() => {
                return process.env.VUE_APP_TIKTOK
            })

            const companyInfo = computed(() => {
                return store.state.countries.company_info
            })
            
            const is_omt_flow = computed(() => {
                try {
                    return (router.currentRoute.value.query?.channel?.toString().toLowerCase() === 'omt');
                } catch {
                    return false;
                }
            });


            return {
                language,
                linkedin,
                facebook,
                instagram,
                tiktok,
                email,
                websiteUrl,
                companyInfo,
                is_omt_flow
            }
        },
    })
